module.exports = __webpack_public_path__ + "img/img24.4e59cceb.png";